import create from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

export const practiceStore = create((set) => ({
  practiceSessionReport: emptyObject,
  isPlanner: false,
  finishPlannerPracticeSession: (sessionReport, isPlanner) =>
    set((state) => ({
      ...state,
      isPlanner,
      practiceSessionReport: sessionReport
    }))
}));

const usePracticeStore = createHook(practiceStore);

export default usePracticeStore;
